import React, { useState, useEffect } from "react";
import {
  Grid,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
} from "@material-ui/core";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import SearchIcon from "@material-ui/icons/Search";
import { useForm } from "react-hook-form";
import { isDate } from "moment";

const CustomSelect = ({
  Name,
  Label,
  Value,
  Error,
  ChangeFunction,
  DataList,
}) => (
  <FormControl
    variant="outlined"
    fullWidth={true}
    size="small"
    error={Error ?? false}
  >
    <InputLabel>{Label}</InputLabel>
    <Select
      variant="outlined"
      value={Value}
      onChange={ChangeFunction}
      name={Name}
      label={Label}
      error={Error ?? false}
    >
      <MenuItem value="">
        <em>Todos</em>
      </MenuItem>
      {DataList &&
        DataList.map((item) => (
          <MenuItem key={item.key} value={item.value}>
            {item.text}
          </MenuItem>
        ))}
    </Select>
  </FormControl>
);

const CustomDatePicker = ({
  Name,
  Value,
  Label,
  ChangeFunction,
  Max,
  Min,
  Disabled,
}) => (
  <FormControl variant="outlined" fullWidth={true} size="small">
    <KeyboardDatePicker
      className="c-date-picker"
      format="dd/MM/yyyy"
      name={Name}
      label={Label}
      inputVariant="outlined"
      okLabel="Seleccionar"
      cancelLabel="Cancelar"
      invalidDateMessage="Fecha incorrecta"
      maxDateMessage="Fecha incorrecta"
      minDateMessage="Fecha incorrecta"
      value={Value ?? null}
      onChange={ChangeFunction}
      minDate={Min ?? false}
      maxDate={Max ?? new Date()}
      disableFuture={true}
      disabled={Disabled}
    />
  </FormControl>
);

export default function AgreementMassiveCreate({
  IsSearching,
  FilterForm,
  SetFilterForm,
  ExternalAgreementStatesList,
  SubmitFunction,
}) {
  const [statusValue, setStatusValue] = useState();
  const { handleSubmit } = useForm();

  function setFilterData(e) {
    if (e.target.name === "externalAgreementStatus") {
      setStatusValue(e.target.value);
      if (!e.target.value) {
        FilterForm.dateFrom = null;
        FilterForm.dateTo = null;
      }
    }
    setData(e.target.name, e.target.value);
  }

  function setData(name, value) {
    SetFilterForm({ ...FilterForm, [name]: value });
  }

  return (
    <form onSubmit={handleSubmit(SubmitFunction)}>
      <Grid container spacing={1}>
        <Grid item xs={4}>
          <CustomSelect
            Name="externalAgreementStatus"
            Label="Estado"
            ChangeFunction={setFilterData}
            DataList={ExternalAgreementStatesList}
          />
        </Grid>
        <Grid item md={3} xs={12}>
          <CustomDatePicker
            Name="dateFrom"
            Label="Fecha desde"
            Value={FilterForm.dateFrom}
            Max={FilterForm.dateTo}
            Disabled={!statusValue}
            ChangeFunction={(e, v) => setData("dateFrom", e)}
          />
        </Grid>
        <Grid item md={3} xs={12}>
          <CustomDatePicker
            Name="dateTo"
            Label="Fecha hasta"
            Value={FilterForm.dateTo}
            Min={FilterForm.dateFrom}
            Disabled={!FilterForm.dateFrom}
            ChangeFunction={(e, v) => setData("dateTo", e)}
          />
        </Grid>
        <Grid item md={2} xs={12}>
          <Button
            className="c-btn-info c-mt-2"
            variant="contained"
            fullWidth={true}
            type="submit"
            startIcon={<SearchIcon />}
            //disabled={!statusValue}
          >
            Buscar
          </Button>
        </Grid>
      </Grid>
    </form>
  );
}
